<template>
  <div class="actions flex" :class="bg">
    <div class="item flex">
      <i class="iconfont icon-eye-line" />
      <span>{{ viewTotalNum || 0 }}</span>
    </div>
    <div class="item flex" @click="doChangeCollect">
      <i class="iconfont "
        :class="[isCollect ? 'icon-star-fill' : 'icon-star-line', isClickCollect ? bg == 'red' ? `addAnima${bg}` : 'addAnima' : '']" />
      <span>{{ collectTotalNum || 0 }}</span>
    </div>
    <div class="item flex" @click="doChangeLike">
      <i class="iconfont2 "
        :class="[isLike ? 'icon2-thumb-up-fill' : 'icon2-thumb-up-line', isClickLike ? bg == 'red' ? `addAnima${bg}` : 'addAnima' : '']" />
      <span>{{ likeTotalNum || 0 }}</span>
    </div>
    <div class="item flex" v-if="!noShare">
      <el-tooltip popper-class="sharePop" placement="bottom" effect="light">
        <div class="shareList" slot="content">
          <div class="tit">分享到：</div>
          <div class="list flex">
            <div class="items flex-bd">
              <el-tooltip popper-class="wechatPop" effect="light" placement="top">
                <div slot="content">
                  <WechatQr :path="fullPath" v-if="fullPath" @loaded="onLoaded" />
                </div>
                <div>
                  <div class="icon flex jc">
                    <svg data-v-75612277="" width="40" height="40" viewBox="0 0 40 40" fill="none"
                      xmlns="http://www.w3.org/2000/svg" class="share-btn-icon">
                      <circle cx="20" cy="20" r="20" fill="#57BB40"></circle>
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M19.7168 13.7118C19.0097 13.7118 18.4441 14.2616 18.4441 14.9491C18.4441 15.6366 19.0097 16.1864 19.7168 16.1864C20.424 16.1864 20.9896 15.6366 20.9896 14.9491C20.9896 14.2616 20.424 13.7118 19.7168 13.7118ZM13.6355 13.7118C12.9292 13.7118 12.3628 14.2616 12.3628 14.9491C12.3628 15.6366 12.9292 16.1864 13.6355 16.1864C14.3427 16.1864 14.909 15.6366 14.909 14.9491C14.909 14.2616 14.3427 13.7118 13.6355 13.7118ZM17.1724 22.9225C17.1724 23.61 17.314 24.2974 17.5964 24.8472H16.7484C15.7581 24.8472 14.6269 24.7104 13.6366 24.4351L10.1016 26.0845L10.9503 23.3347C8.68727 21.9605 7.27295 19.8982 7.27295 17.4236C7.27295 13.2996 11.5159 10 16.6068 10C21.273 10 25.0919 12.7498 25.7991 16.1863H25.0919C20.7074 16.1863 17.1724 19.2107 17.1724 22.9225ZM27.9199 19.8983C27.3543 19.8983 26.9296 20.3105 26.9296 20.8603C26.9296 21.4109 27.3543 21.8231 27.9199 21.8231C28.4855 21.8231 28.9102 21.4109 28.9102 20.8603C28.9102 20.3105 28.4855 19.8983 27.9199 19.8983ZM22.8285 19.8983C22.263 19.8983 21.839 20.3105 21.839 20.8603C21.839 21.4109 22.263 21.8231 22.8285 21.8231C23.3941 21.8231 23.8181 21.4109 23.8181 20.8603C23.8181 20.3105 23.3941 19.8983 22.8285 19.8983ZM29.7576 28.0091L30.4647 30.2083L27.9193 28.8342C27.0705 29.1087 26.2226 29.2464 25.233 29.2464C21.1308 29.2464 17.7374 26.4965 17.7374 23.06C17.7374 19.6235 21.1308 16.8737 25.233 16.8737C29.3336 16.8737 32.727 19.6235 32.727 23.06C32.727 24.9847 31.5966 26.7718 29.7576 28.0091Z"
                        fill="white"></path>
                    </svg>
                  </div>
                  <div class="fonts">微信</div>
                </div>
              </el-tooltip>
            </div>
            <div class="items flex-bd" @click="copyData">
              <div class="icon flex jc">
                <svg data-v-75612277="" width="40" height="40" viewBox="0 0 40 40" fill="none"
                  xmlns="http://www.w3.org/2000/svg" class="share-btn-icon">
                  <circle cx="20" cy="20" r="20" fill="#4CA2E5"></circle>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M29.0365 24.2657C28.9059 22.7032 28.0439 20.9636 27.6915 20.0894L26.7801 17.8395C26.7515 16.9025 27.0413 14.7516 25.5216 12.0594C23.9972 9.36651 20.9438 9.12432 20.3787 9.09627C19.8136 9.06821 16.2817 9.04089 14.5447 11.9715C12.8077 14.9015 13.277 17.8395 13.277 17.8395L12.3053 20.1049C12.3053 20.1049 11.8538 21.1393 11.4627 22.3968C11.0715 23.6543 10.6796 25.6317 11.0715 26.0334C11.4627 26.435 12.8804 24.194 13.011 23.9866C13.011 23.9866 13.1123 25.0565 13.3805 25.6177C13.5954 26.0659 14.1103 27.1845 15.1515 28.0617C14.6514 28.216 13.4509 28.6288 13.2739 29.0578C13.052 29.6027 13.4478 29.667 14.1242 29.7039C14.8006 29.7408 18.0426 29.8242 19.5964 29.6168C19.6134 29.6138 19.6273 29.6116 19.6443 29.6094C19.7966 29.6138 19.9388 29.6168 20.0764 29.6168C20.1638 29.6168 20.2651 29.6138 20.374 29.6116C20.3841 29.6138 20.3957 29.6138 20.4057 29.6168C21.9587 29.8242 25.2031 29.7408 25.8772 29.7039C26.5536 29.667 26.947 29.6027 26.7275 29.0578C26.5482 28.6214 25.3144 28.2042 24.829 28.0565C24.9805 27.9273 25.1281 27.7885 25.2734 27.6386C27.0243 25.8 26.8798 24.6393 26.9524 23.9747C26.9524 23.9747 28.4281 26.0075 28.7466 26.0769C29.0659 26.1463 29.1648 25.8274 29.0365 24.2657Z"
                    fill="white"></path>
                </svg>
              </div>
              <div class="fonts">QQ</div>
            </div>
            <!-- <div class="items flex-bd" @click="onShareQQZone">
              <div class="icon flex jc">
                <svg data-v-75612277="" width="40" height="40" viewBox="0 0 40 40" fill="none"
                  xmlns="http://www.w3.org/2000/svg" class="share-btn-icon">
                  <circle cx="20" cy="20" r="20" fill="#F4BF41"></circle>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.7608 17.8223L18.7132 22.8777C18.7132 22.8777 21.5417 23.2974 25.8074 23.2492L25.6134 22.4129L31.6916 17.147C31.8029 17.05 31.8457 16.8958 31.7999 16.7552C31.7547 16.6145 31.6291 16.5145 31.481 16.5025L23.4685 15.8143L20.3384 8.40576C20.2812 8.27038 20.1474 8.18164 20 8.18164C19.8526 8.18164 19.7187 8.27038 19.6615 8.40576L16.5307 15.8143L8.51822 16.5025C8.37081 16.5145 8.24522 16.6145 8.19934 16.7552C8.15422 16.8958 8.19708 17.05 8.30839 17.147L14.3866 22.4129L12.5651 30.2472C12.5312 30.3901 12.5869 30.5405 12.7065 30.6277C12.8268 30.7135 12.9862 30.7195 13.1133 30.6443L20 26.4906L26.8866 30.6443C26.9453 30.6811 27.0107 30.6969 27.0769 30.6969C27.1536 30.6969 27.2288 30.6744 27.2927 30.6277C27.4123 30.5405 27.4687 30.3901 27.4349 30.2472L25.9947 24.0517C26.6121 23.7411 27.2927 23.2154 27.2927 23.2154C27.2927 23.2154 24.5958 24.5323 14.9138 23.8885L21.9305 18.803C21.9305 18.803 21.6545 18.3736 12.8606 18.0675C12.2718 18.0472 20.0301 16.5965 25.7608 17.8223Z"
                    fill="white"></path>
                </svg>
              </div>
              <div class="fonts">QQ空间</div>
            </div> -->
            <div class="items flex-bd" @click="onShareBlog">
              <div class="icon flex jc">
                <svg data-v-75612277="" width="40" height="40" viewBox="0 0 40 40" fill="none"
                  xmlns="http://www.w3.org/2000/svg" class="share-btn-icon">
                  <circle cx="20" cy="20" r="20" fill="#DB4437"></circle>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M27.6183 16.703C27.2244 16.703 26.8309 16.3091 26.8309 15.9156C26.9618 14.9968 26.4369 14.078 25.3868 13.8157H24.9933C24.5993 13.8157 24.2058 13.4218 24.2058 13.0282C24.2058 12.6343 24.5993 12.2408 24.9933 12.2408C26.8309 12.2408 28.2745 13.6844 28.2745 15.5216V15.7842C28.2745 16.4404 28.0123 16.703 27.6183 16.703ZM17.6437 23.1338C17.3811 23.1338 17.2497 23.3965 17.2497 23.6591C17.2497 23.9213 17.5124 24.0526 17.6437 24.0526C17.7746 24.0526 18.0372 23.7904 18.0372 23.6591C18.1685 23.3965 17.9059 23.1338 17.6437 23.1338ZM15.4125 23.5278C14.7564 23.5278 14.2311 24.0526 14.2311 24.7088C14.2311 25.3654 14.7564 25.8902 15.4125 25.8902C16.0687 25.8902 16.5936 25.3654 16.5936 24.7088C16.5936 24.0526 16.0687 23.5278 15.4125 23.5278ZM17.5124 27.2026C15.4125 27.7274 13.3127 26.809 12.9188 24.9718C12.5252 23.1338 13.8376 21.4279 15.9374 20.9031C18.0372 20.3782 20.1371 21.2966 20.531 23.1338C20.9245 24.9718 19.6122 26.6777 17.5124 27.2026ZM16.9871 18.9342C13.0501 19.1968 9.90014 21.4279 10.0315 24.0526C10.1624 26.6777 13.5749 28.5149 17.5124 28.2527C21.4498 27.9901 24.5993 25.7593 24.4684 23.1338C24.3371 20.5091 20.9245 18.8029 16.9871 18.9342ZM24.4684 15.3907C26.1743 16.1782 25.1246 19.3281 25.1246 19.3281C26.0434 19.4594 26.8309 19.853 27.487 20.5091C29.3246 22.609 27.7496 27.0716 21.4498 29.1715C15.8061 31.0087 10.1624 29.1715 8.58779 25.6276C7.01283 21.8215 10.1624 16.0469 15.5435 13.0282C16.2 12.6343 18.2998 11.9781 19.4813 13.2909C20.1371 14.078 19.4813 16.3091 19.4813 16.3091C19.4813 16.3091 21.9746 14.2093 24.4684 15.3907ZM31.6871 16.703C31.6871 17.2283 31.1618 17.7531 30.637 17.7531C30.1121 17.7531 29.5869 17.2283 29.5869 16.703V16.5717C29.9804 13.947 28.1432 11.5846 25.5185 11.1907H24.862H24.731C24.2058 11.1907 23.6809 10.6658 23.6809 10.1409C23.6809 9.61606 24.2058 9.09082 24.731 9.09082H24.862C28.6681 9.09082 31.818 12.2408 31.818 16.0469V16.5717C31.6871 16.5717 31.6871 16.703 31.6871 16.703Z"
                    fill="white"></path>
                </svg>
              </div>
              <div class="fonts">微博</div>
            </div>
          </div>
        </div>
        <div class="flex">
          <i class="iconfont2 icon2-share-forward-line" />
          <span>分享</span>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import WechatQr from "@/components/common/WechatQr";
export default {
  props: {
    banner: String | Number,
    type: String | Number,
    view: String | Number,
    collect: String | Number,
    like: String | Number,
    row: Object,
    bg: String,
    noShare: Boolean
  },
  components: {
    WechatQr
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      viewTotalNum: 0,
      collectTotalNum: 0,
      likeTotalNum: 0,
      isClickCollect: false,
      isClickLike: false,
      isCollect: false,
      isLike: false,
      sharePath: '',
      fullPath: '',
      mPath: '',
      gdwhglikeId: '',
    };
  },
  created() {
    this.doChangeCollect = this._debounce(this.onChangeCollect, 300, true);
    this.doChangeLike = this._debounce(this.onChangeLike, 300, true);
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.viewTotalNum = this.view || 0
      this.collectTotalNum = this.collect || 0
      this.likeTotalNum = this.like || 0
      if (this.userInfo && this.userInfo.id) {
        this.checkIsCollect()
      }
      this.checkIsLike()
      this.onChangeView()

      this.fullPath = this.$route.fullPath
      this.sharePath = window.location.origin + this.fullPath
    },
    async checkIsCollect() {
      this.isCollect = await this.getCheckInfo({ category: 4 })
    },
    async checkIsLike() {
      if (!this.userInfo || !this.userInfo.id) {
        this.gdwhglikeId = localStorage.getItem('GDWHGLIKES') || ''
      }
      this.isLike = await this.getCheckInfo({ category: 3 })
    },
    async getCheckInfo(data) {
      const params = {
        ...data,
        banner: this.banner,
        vid: this.row.id,
      }
      if (this.userInfo && this.userInfo.id) {
        params.user_id = this.userInfo.id
      } else {
        if (data.category == 3) {
          if (!this.gdwhglikeId) {
            const gdwhglikeId = this.createRandomId()
            this.gdwhglikeId = gdwhglikeId
          }
          params.user_id = this.gdwhglikeId
        }
      }
      const res = await this.$api.recordApi.checkUserAction(params)
      return !!res.data
    },
    async onCHeckLogin() {
      return new Promise((resolve, reject) => {
        if (this.userInfo && JSON.stringify(this.userInfo) != '{}') {
          resolve()
        } else {
          this.$confirm(`您还未登录，点击登录`, "温馨提示", { type: "warning", lockScroll: false }).then(() => {
            const tempRoute = this.$route.path.replace(/\//g, '-')
            let link = this.$router.resolve({
              path: `/login/${tempRoute}`
            })
            window.open(link.href, '_blank');
          })
        }
      })
    },
    async onChangeCollect() {
      await this.onCHeckLogin()
      this.saveUserData({ category: 4 })
      this.isCollect = !this.isCollect
      if (this.isCollect) {
        this.isClickCollect = true
        this.collectTotalNum++
      } else {
        this.isClickCollect = false
        this.collectTotalNum--
      }
      this.collectTotalNum = Math.max(0, this.collectTotalNum)
    },
    createRandomId() {
      const gdwhglikeId = Math.floor(Math.random()*100000)
      localStorage.setItem('GDWHGLIKES', gdwhglikeId)
      return gdwhglikeId
    },
    async onChangeLike() {
      if (!this.userInfo || !this.userInfo.id) {
        let gdwhglikeId = localStorage.getItem('GDWHGLIKES') || ''
        if (!gdwhglikeId) {
          gdwhglikeId = this.createRandomId()
        }
        this.gdwhglikeId = gdwhglikeId
      }
      this.saveUserData({ category: 3 })
      this.isLike = !this.isLike
      
      if (this.isLike) {
        this.isClickLike = true
        this.likeTotalNum++
      } else {
        this.isClickLike = false
        this.likeTotalNum--
      }
      this.likeTotalNum = Math.max(0, this.likeTotalNum)
    },
    onChangeView() {
      this.saveUserData({ category: 1 })
    },
    async saveUserData(data) {
      const params = {
        ...data,
        banner: this.banner,
        type: this.row.category || this.row.type_id,
        vid: this.row.id
      }
      if (this.userInfo && this.userInfo.id) {
        params.user_id = this.userInfo.id
      } else {
        if (data.category == 3) {
          params.user_id = this.gdwhglikeId
        }
      }
      await this.$api.recordApi.addUserAction(params)
    },
    onLoaded(mPath) {
      this.mPath = mPath
    },
    copyData() {
      this.$copyText(this.mPath || this.sharePath).then(() => {
        this.$msg('已成功复制到剪贴板')
      })
    },
    onShareQQZone() {

      // var p = {
      //   url: this.sharePath,
      //   showcount: 1,
      //   desc: '唱《奢香夫人》，做气质学生 UP主：努力生活的西鱼',
      //   summary: '唱《奢香夫人》，做气质学生 UP主：努力生活的西鱼',
      //   title: '奢香夫人',
      //   site: '哔哩哔哩',
      //   pics: 'http://i2.hdslb.com/bfs/archive/0679830851beda80484f06046ae9ca2a55b42e57.jpg',
      //   style: "203",
      //   width: 98,
      //   height: 22
      // };
      // var s = [];
      // for (var i in p) {
      //   s.push(i + '=' + encodeURIComponent(p[i] || ''));
      // }
      
      // var target_url =
      //   "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" + s.join('&');

      //   console.log('url: ', target_url)
      //   return window.open(target_url, "", "width=760, height=640, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, location=yes, resizable=no, status=no")

    },
    onShareBlog() {
      const params = {
        title: this.row.name || this.row.title,
        pic: this.row.cover_img,
        sharePath: this.sharePath
      }
      this.$utils.shareToWeibo(params)
    },
  }
};
</script>

<style lang="scss">
.sharePop {
  border-color: #cdcdcd !important;
  box-shadow: 0 4px 10px 0 rgba($color: #000, $alpha: 0.15) !important;

  .popper__arrow {
    border-bottom-color: #cdcdcd !important;
  }
}
</style>
<style lang="scss" scoped>
.actions {
  flex-shrink: 1;
  height: 36px;
  color: #6D6D6D;

  &.red {
    color: #FFF;

    .item {
      i {

        &.icon2-thumb-up-fill,
        &.icon-star-fill {
          color: #FFF;
        }

        &.addAnimared {
          animation: addSignRed .5s ease-in-out forwards;
        }
      }
    }
  }

  .item {
    &+.item {
      margin-left: 30px;
    }

    cursor: pointer;

    i {
      margin-right: 7px;

      &.icon2-thumb-up-fill,
      &.icon-star-fill {
        color: #F3171B;
      }

      &.addAnima {
        animation: addSign .5s ease-in-out forwards;
      }
    }

    &:first-child {
      cursor: default;
    }
  }
}

@keyframes addSign {
  0% {
    transform: scale(1);
    color: #FFF;
  }

  90% {
    transform: scale(1.4);
  }

  100% {
    transform: scale(1);
    color: #e95044;
  }
}

@keyframes addSignRed {
  0% {
    transform: scale(1);
    color: #FFF;
  }

  90% {
    transform: scale(1.4);
  }

  100% {
    transform: scale(1);
    color: #FFF;
  }
}

.shareList {
  .tit {
    padding: 10px;
    border-bottom: 1px solid #F8F8F8;
  }

  .list {
    padding: 20px 0 10px;

    .items {
      width: 60px;
      cursor: pointer;

      &:hover {
        opacity: .8;
      }

      .fonts {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
}
</style>